export default "__VITE_ASSET__J6dLOba6__"